import styled from 'styled-components';

export const breakpoints = {
    desktop: '1599px',
    sDesktop: '1365px',
    tablet: '1122px',
    mobile: '768px',
    sMobile: '350px',
};

export const Logo = styled.a`
    flex: 0;
    display: flex;
    justify-content: center;
    max-width: 100%;
`;

export const LogoImg = styled.img<{ maxWidth?: string }>`
    flex: 0;
    width: auto;
    height: auto;
    max-width: ${p => p.maxWidth ?? '128px'};
    max-height: 48px;

    @media (max-width: ${breakpoints.sMobile}) {
        max-width: ${p => p.maxWidth ?? '100px'};
    }
`;
